import React, { useState } from "react";
import { MessageCircle, Instagram, Music2, Mail, X } from "lucide-react";
import { profile } from "../mock";

const iconMap = { Instagram: Instagram, TikTok: Music2, Email: Mail };

export default function FloatingContact() {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-6 right-6 z-[90] flex flex-col items-end gap-3">
      <div
        className={`flex flex-col items-end gap-3 transition-all duration-300 ${
          open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
        }`}
      >
        {profile.socials.map((s) => {
          const Icon = iconMap[s.label] || Mail;
          return (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-3"
            >
              <span className="font-body text-xs tracking-wide-2 uppercase bg-[#3A302A] text-[#FAF5EF] px-3 py-2 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-opacity">
                {s.label}
              </span>
              <span className="w-12 h-12 rounded-full bg-[#FAF5EF] shadow-lg flex items-center justify-center text-[#B0603F] border border-[#E7D8C6] hover:bg-[#B0603F] hover:text-[#FAF5EF] transition-colors">
                <Icon size={20} />
              </span>
            </a>
          );
        })}
      </div>

      <button
        onClick={() => setOpen(!open)}
        aria-label="Contact rapide"
        className="w-14 h-14 rounded-full bg-[#B0603F] text-[#FAF5EF] shadow-xl flex items-center justify-center hover:bg-[#8F4A2E] transition-all duration-300 hover:scale-105"
      >
        {open ? <X size={24} /> : <MessageCircle size={24} />}
      </button>
    </div>
  );
}
